module.exports = __webpack_public_path__ + "img/konbini-17022022.f4a9a857.jpg";